import * as React from 'react';
import { Avatar, Box, IconButton, MenuItem, Stack, Tooltip } from '@mui/material';
import { IAccountButtonProps } from './types';
import { theme } from '../../../../../common/styles/theme';
import { LoginAsItem } from '../../LoginAsItem/LoginAsItem';
import { IconMenuItem } from '../../../../../common/components/IconMenuItem/IconMenuItem';
import { LogoutIcon } from '../../../../../../icons/LogoutIcon';
import { ArrowCircleIcon } from '../../../../../../icons/ArrowCircleIcon';
import { ButtonMenu } from '../../../../../common/components/ButtonMenu/ButtonMenu';

export const AccountButton: React.FC<IAccountButtonProps> = ({
	userExist,
	userName,
	userPicture,
	isAdmin,
	isLogged,
	onSignOut,
	onSwitchAccount,
	onShowAdminPanel,
	onLoginAs,
	onLogin,
}) => {

	let [menuOpen, setMenuOpen] = React.useState(false);
	const data = React.useRef({ menuOpen });
	data.current = { menuOpen };
	const handleMenu = (open = !data.current.menuOpen) => {
		setMenuOpen(open);
	}

	const handleSwitchAccount = () => {
		onSwitchAccount();
	}

	const handleSignOut = () => {
		onSignOut();
	}

	const handleLoginAs = (email: string) => {
		onLoginAs(email);
	}

	if (!userExist) return null;

	return isLogged
		? <>

			<ButtonMenu
				buttonProps={{
					sx: {
						p: 0,
					},
					children: (
						<Stack
							flexDirection={'row'}
							justifyContent={'center'}
							alignItems={'center'}
							sx={{
								position: 'relative',
								width: theme.spacing(5),
								height: theme.spacing(5),
								m: `0 !important`,
								color: theme.palette.grey[400],
								borderRadius: '50%',
								cursor: 'pointer',
								transition: 'all .3s ease',
								background: theme.palette.grey[100],

								'.MuiAvatar-root': {
									transition: 'all .3s ease',
								},

								'&:hover .MuiAvatar-root': {
									zIndex: 10,
									transform: 'scale(1.25)',
								},
							}}
						>
							<Avatar
								src={userPicture}
								alt={userName}
								sx={{ width: theme.spacing(4), height: theme.spacing(4) }}
							/>
						</Stack>
					),
				}}
				menuProps={{
					open: !!menuOpen,
					keepMounted: true,
					anchorOrigin: {
						vertical: 'bottom',
						horizontal: 'right',
					},
					transformOrigin: {
						vertical: 'top',
						horizontal: 'right',
					},
					sx: {
						m: theme.spacing(.5, 0, 0, 0),

						'.MuiMenuItem-root': {
							pl: 0,
						},
					},
				}}
				onOpen={() => handleMenu(true)}
				onClose={() => handleMenu(false)}
			>

				<IconMenuItem
					title={'Switch account'}
					onClick={handleSwitchAccount}
				>
					<ArrowCircleIcon />
				</IconMenuItem>
				<IconMenuItem
					title={'Logout'}
					onClick={handleSignOut}
				>
					<LogoutIcon
						sx={{
							width: theme.spacing(2.25) + ' !important',
							transform: 'translateX(2px)'
						}}
					/>
				</IconMenuItem>

				<>{isAdmin &&
					<Box
						sx={{
							pl: theme.spacing(2),
						}}
					>
						<MenuItem onClick={onShowAdminPanel}>Admin Console</MenuItem>
						<MenuItem>
							<LoginAsItem onClick={handleLoginAs} />
						</MenuItem>
					</Box>
				}</>
			</ButtonMenu>
		</>
		: <Tooltip
			title={'Login'}
		>
			<IconButton
				sx={{
					width: theme.spacing(5),
					height: theme.spacing(5),
					p: theme.spacing(.5),

					'&:hover .MuiAvatar-root': {
						background: theme.palette.grey[500],
					},
				}}
				onClick={onLogin}
			>
				<Avatar
					sx={{ width: theme.spacing(4), height: theme.spacing(4) }}
				/>
			</IconButton>
		</Tooltip>
};
